<div class="container-fluid cw-background">
  <div class="row d-flex justify-content-center">
    <div class="col-12 col-sm-9 col-sm-offset-1 col-md-9 col-md-offset-1 col-lg-4 col-lg-offset-4 mt-5 mb-5">
      <mat-card class="mat-elevation-z8" id="card">
        <div class="text-left go-back d-block">
          <div class="company-create-controls-wrapper">
            <button (click)="goBack()" disableRipple mat-button class="delete-user p-0">
              <mat-icon matPreffix>arrow_back_ios</mat-icon>
              Go Back
            </button>
            <button (click)="navigateToBulkMode()" disableRipple mat-button class="delete-user p-0">
              Bulk upload
              <mat-icon matPreffix>backup</mat-icon>
            </button>
          </div>

          <h6 class="text-center card-title-page mt-4 mb-4">Create New Company:</h6>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-12 col-sm-9 col-sm-offset-1">
            <app-dynamic-form [questions]="questions" (formSubmit)="onSubmit($event)"> </app-dynamic-form>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
